export function repeat(str: string, times: number): string {
  return Array(times).fill(str).join('');
}

export const range = (start: number, end: number, step: number = 1): number[] => {
  if (start > end && step > 0) {
    step = -step;
  }
  const result = [];
  for (let i = start; step > 0 ? i <= end : i >= end; i += step) {
    result.push(i);
  }

  return result;
};
